import { useAppSelector } from "@/store/hooks";
import { Category } from "@/store/slices/storeSlice";
import { X } from "lucide-react";
import DynamicCategorySelector from "../DynamicCategorySelector";

interface CategorySelectorProps {
  title: string;
  selectedCategories: number[];
  onChange: (categories: number[]) => void;
}

const CategorySelector = ({
  title,
  selectedCategories,
  onChange,
}: CategorySelectorProps) => {
  const { portal } = useAppSelector((state) => state.store);

  const handleAddCategory = (categoryId: number) => {
    if (!selectedCategories.includes(categoryId)) {
      onChange([...selectedCategories, categoryId]);
    }
  };

  const handleRemoveCategory = (categoryId: number) => {
    onChange(selectedCategories.filter((id) => id !== categoryId));
  };

  const getCategoryById = (id: number): Category | undefined => {
    return portal?.cats?.find((cat) => cat.term_id === id);
  };

  const getCategoryName = (cat: Category) => {
    return decodeURIComponent(cat.name?.split("|")[0]);
  };

  const getCategoryType = (cat: Category) => {
    return cat.parent ? "قسم فرعي" : "قسم رئيسي";
  };

  const availableCategories = portal?.cats?.filter(
    (cat) => !selectedCategories.includes(cat.term_id)
  );

  return (
    <div className="mb-4">
      <label className="block font-bold mb-2">{title}</label>

      {/* <select
        className="border border-gray-300 rounded-md p-2 w-full mb-2 focus:outline-none focus:ring-2 focus:ring-primary"
        value=""
        onChange={(e) => {
          if (e.target.value) {
            handleAddCategory(Number(e.target.value));
          }
        }}
      >
        <option value="">اختر قسم...</option>
        {availableCategories?.map((cat) => (
          <option key={cat.term_id} value={cat.term_id}>
            {getCategoryName(cat)}
          </option>
        ))}
      </select> */}

      <DynamicCategorySelector
        styles="border border-gray-300 rounded-md p-2 mb-2 focus:outline-none focus:ring-2 focus:ring-primary flex-1"
        filteredCats={availableCategories}
        showConfirmSelectionBtn={true}
        excludeCatsThatHasLessons={false}
        confirmSelectionBtnText="أضف هذا القسم"
        confirmSelectionHandlerFunction={(obj) => {
          if (obj?.id) {
            handleAddCategory(Number(obj.id));
          }
        }}
      />

      <div className="flex flex-wrap gap-2">
        {selectedCategories.map((catId) => {
          const category = getCategoryById(catId);
          if (!category) return null;

          return (
            <span
              key={catId}
              className="bg-green-100 border border-green-400 py-1 px-3 rounded-md flex items-center gap-2 cursor-pointer hover:bg-green-200 transition-colors"
              onClick={() => handleRemoveCategory(catId)}
            >
              {getCategoryName(category)}
              <X className="size-4" />
            </span>
          );
        })}
      </div>

      {selectedCategories.length === 0 && (
        <p className="text-sm text-gray-500 mt-2">لم يتم اختيار أي قسم</p>
      )}
    </div>
  );
};

export default CategorySelector;
